import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/AnchoredOverlay/AnchoredOverlay.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <DeprecationBanner replacementUrl={'/design/components/anchored-overlay/react'} mdxType="DeprecationBanner" />
    <p>{`An `}<inlineCode parentName="p">{`AnchoredOverlay`}</inlineCode>{` provides an anchor that will open a floating overlay positioned relative to the anchor.
The overlay can be opened and navigated using keyboard or mouse.`}</p>
    <p>{`See also `}<a parentName="p" {...{
        "href": "/Overlay#positioning"
      }}>{`Overlay positioning`}</a>{`.`}</p>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<State default={false}>
  {([isOpen, setIsOpen]) => {
    const openOverlay = React.useCallback(() => setIsOpen(true), [setIsOpen])
    const closeOverlay = React.useCallback(() => setIsOpen(false), [setIsOpen])
    return (
      <AnchoredOverlay
        renderAnchor={anchorProps => (
          <Button {...anchorProps} trailingAction={TriangleDownIcon}>
            Click me to open
          </Button>
        )}
        open={isOpen}
        onOpen={openOverlay}
        onClose={closeOverlay}
      >
        <Box display="flex" flexDirection="column" maxWidth="300px" padding={2}>
          <p>
            This menu automatically receives a focus trap and focus zone. Use up/down keys to navigate between buttons
          </p>
          <Button mb={1}>Button 1</Button>
          <Button mb={1}>Button 2</Button>
          <Button>Button 3</Button>
        </Box>
      </AnchoredOverlay>
    )
  }}
</State>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: false,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      